"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _jwtSimple = require("jwt-simple");

var _jwtSimple2 = _interopRequireDefault(_jwtSimple);

var getIssuedAt = function getIssuedAt() {
    return Math.round(new Date().getTime() / 1000) - 60;
};

var getExpiresAt = function getExpiresAt() {
    return Math.round(new Date().getTime() / 1000) + 86400;
};

var getAppTokenPayload = function getAppTokenPayload(authData) {
    var roles = {};

    (authData.roles || []).forEach(function (role) {
        roles[role] = true;
    });

    return {
        "aud": "https://ergeon.in/",
        "claims": roles,
        "email": authData.email,
        "exp": getExpiresAt(),
        "first_name": authData.first_name,
        "iat": getIssuedAt(),
        "iss": "internal@ergeon.in",
        "jti": "xziKNbHEPqu6m2J4vPzHbA",
        "last_name": authData.last_name,
        "nbf": 1539769907,
        "scope": "",
        "sub": "internal@ergeon.in",
        "uid": authData.uid
    };
};

var createFakeToken = function createFakeToken(payload, secret) {
    return JSON.stringify(_jwtSimple2["default"].encode(payload, secret));
};

var createFakeAppToken = function createFakeAppToken(authData, secret) {
    return createFakeToken(getAppTokenPayload(authData), secret);
};

var createFakeApiToken = function createFakeApiToken() {
    return createFakeToken({}, "fake-secret");
};

exports.createFakeApiToken = createFakeApiToken;
exports.createFakeAppToken = createFakeAppToken;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-auth/dist/fakeToken.js
 ** module id = 777
 ** module chunks = 0
 **/